import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLightbulb } from "@fortawesome/pro-solid-svg-icons";

import { useDebounce } from "@react-hook/debounce";
import { searchSideLoadedBusinessesCount } from "selectors";
import { SlimSecondaryButton } from "components/Button";
import SideLoadFieldCompareModal from "components/Business/SideLoadedBusinesses/CompareModal/SideLoadedFieldCompareModal";
import SideLoadedBusinessTable from "components/Business/SideLoadedBusinesses/SideLoadedBusinessTable";
import { SideLoadedSelectValues } from "components/Business/SideLoadedBusinesses/CompareModal/SideLoadedFieldCompareModal";
interface SideLoadedBusinessAlertControllerProps {
  searchValues: string;
  ns: string;
  handlePopulateSideloadBusiness: (
    selectedValues: SideLoadedSelectValues,
  ) => void;
  businessId: string;
}

export function SideLoadedBusinessAlertController({
  searchValues,
  handlePopulateSideloadBusiness,
  businessId,
}: SideLoadedBusinessAlertControllerProps) {
  const [debouncedSearchValue, setDebouncedSearchValue] = useDebounce(
    searchValues,
    300,
  );

  React.useEffect(() => {
    setDebouncedSearchValue(searchValues);
  }, [searchValues, setDebouncedSearchValue]);

  const sideLoadResultCount = useSelector(
    searchSideLoadedBusinessesCount(debouncedSearchValue),
  );

  const isOn = sideLoadResultCount > 0;

  const [fieldCompareRecordId, setFieldCompareRecordId] = useState(null);

  const [isBrowserOpen, setIsBrowserOpen] = useState(false);

  const handleClick = () => {
    setIsBrowserOpen(true);
  };

  const handleBack = () => {
    setIsBrowserOpen(true);
    setFieldCompareRecordId(null);
  };

  const handleSelect = (selectedValues: SideLoadedSelectValues) => {
    setFieldCompareRecordId(null);
    setIsBrowserOpen(false);
    handlePopulateSideloadBusiness(selectedValues);
  };

  return (
    <>
      <SlimSecondaryButton
        onClick={handleClick}
        verticalMargin={2}
        disabled={!isOn}
      >
        <FontAwesomeIcon icon={faLightbulb} />
        &nbsp;{sideLoadResultCount}&nbsp;suggested
      </SlimSecondaryButton>

      {isBrowserOpen && (
        <SideLoadedBusinessTable
          initialSearchTerm={debouncedSearchValue}
          onClose={() => setIsBrowserOpen(false)}
          onSelect={setFieldCompareRecordId}
        />
      )}
      {fieldCompareRecordId && (
        <SideLoadFieldCompareModal
          recordId={fieldCompareRecordId}
          onClose={() => setFieldCompareRecordId(null)}
          businessId={businessId}
          onSelect={handleSelect}
          onBack={handleBack}
        />
      )}
    </>
  );
}
